module.exports = __webpack_public_path__ + "assets/img/88_725_3.b26e91f0.jpg";